// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"1613de0c","340":"5becb770","367":"b78fe88f","416":"56767bfd","705":"ad84a90b"}[chunkId] + ".chunk.css";
};